<template>
  <div class="product-unit-table">
    <form class="product-unit-table__head">
      <div class="product-unit-table__cell">№</div>
      <input-sort
        v-model="sortByName"
        v-on:input="sortProductUnitListByName"
        name="name"
      >
        <div
          class="product-unit-table__cell sort"
          v-bind:class="{ selected: sortByName ? 'selected' : '' }">
          Наименование</div>
      </input-sort>
      <div class="product-unit-table__cell">Краткое название</div>
    </form>
    <div class="product-unit-table__body-mobile">
      <button
        class="product-unit-table__body-mobile__button-row"
        type="button"
        v-for="({
          id, name, shortName,
        }, index) in productUnitList"
        v-bind:key="id"
        v-on:click="onEditProductUnit(id)">
        <dl class="product-unit-table__body-mobile__row">
          <dt>№</dt>
          <dd>{{ index + 1 }}</dd>
          <dt>Наименование</dt>
          <dd>{{ name }}</dd>
          <dt>Краткое наименование</dt>
          <dd>{{ shortName }}</dd>
        </dl>
      </button>
    </div>
    <div
      v-if="!this.isProductUnitListEmpty && !this.isAwaitRequest"
      class="product-unit-table__body"
    >
      <div
        class="product-unit-table__row"
        v-for="({
          id,
          name,
          shortName,
        }, index) in productUnitList"
        v-bind:key="id">
        <div
          data-label="№"
          class="product-unit-table__cell number">
          {{ index + 1 }}
        </div>
        <button
          class="product-unit-table__cell"
          data-label="Наименование"
          title="Открыть"
          type="button"
          v-on:click="onEditProductUnit(id)"
        >
          {{ name }}
        </button>
        <button
          class="product-unit-table__cell"
          data-label="Краткое наименование"
          title="Открыть"
          type="button"
          v-on:click="onEditProductUnit(id)"
        >
          {{ shortName }}
        </button>
        <div
          data-label="Редактировать"
          class="product-unit-table__cell"
        >
          <button
            class="product-unit-table__icon-edit"
            type="button"
            v-on:click="onEditProductUnit(id)" />
        </div>
        <div
          data-label="Удалить"
          class="product-unit-table__cell">
          <button
            class="product-unit-table__icon-delete"
            type="button"
            v-on:click="onDeleteProductUnit(id)" />
        </div>
      </div>
    </div>
    <div
      v-else-if="!isAwaitRequest"
      class="product-unit-table__message"
    >
      Ничего не найдено
    </div>
  </div>
</template>

<script>
import InputSort from '@/components/InputSort.vue';

/**
 * @description Таблица единиц измерения товаров.
 * @type {Vue}
 */
export default {
  name: 'ProductUnitTable',
  components: { InputSort },
  computed: {
    /**
     * @description Является ли список единиц измерения пустым.
     * @returns {boolean}
     */
    isProductUnitListEmpty() {
      return !Object.keys(this.productUnitList).length;
    },
  },
  created() {
    this.sortByName = this.sort.type === 'name' ? this.sort.order : '';
  },
  data() {
    return {
      sortByName: '',
    };
  },
  methods: {
    /**
     * Сортировать список единиц измерения по полному имени
     */
    sortProductUnitListByName() {
      this.$emit('sort-product-unit-list', {
        type: 'name',
        order: this.sortByName,
      });
    },
    /**
     * @description Обработать удаление единицы измерения.
     * @param {number} id Идентификатор единицы измерения.
     * @returns {void}
     */
    onDeleteProductUnit(id) {
      this.$emit('delete-product-unit', id);
    },
    /**
     * @description Обработать редактирование единицы измерения.
     * @param {number} id Идентификатор единицы измерения.
     * @returns {void}
     */
    onEditProductUnit(id) {
      this.$emit('edit-product-unit', id);
    },
  },
  props: {
    /**
     * @description Список единиц измерения.
     * @type {any[]}
     */
    productUnitList: { type: Array, required: true },
    /**
     * @description Ожидание завершения запроса.
     * @type {boolean}
     */
    isAwaitRequest: { type: Boolean, required: true },
    /**
     * @description Тип сортировки
     * @type {Object}
     */
    sort: { type: Object, default: () => ({ type: '', order: '' }) },
  },
};
</script>

<style lang="scss">

.product-unit-table {
  margin: 25px 0 0 0;
  font-size: 0.875rem;
  line-height: 1rem;
  &__body-mobile {
    display: none;
    flex-direction: column;
    gap: 10px;
    &__button-row {
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
    }
    &__row {
      display: grid;
      font-size: 12px;
      grid-template-columns: auto 1fr;
      justify-items: flex-end;
      align-items: center;
      row-gap: 5px;
      padding: 5px;
      & > dt {
        justify-self: flex-start;
      }
      & > dd {
        text-align: right;
      }
    }
  }
  &__head,
  &__row {
    display: grid;
    grid-template-columns:
      60px
      minmax(200px, 300px)
      minmax(300px, 1fr)
      repeat(2, 43px);
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
  }
  &__row {
    border-bottom: 1px solid #eaeff3;
    padding: 0;
    &:hover {
      background: #eaeff3;
    }
  }
  &__cell {
    padding: 12px 8px;
    text-align: left;
    transition: color var(--animate-duration);
    &.sort {
      text-align: left;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:after {
        content: '';
        background-image: url("@/assets/img/checked/checked-grey.svg");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        width: 10px;
        height: 10px;
        margin: 0 0 0 5px;
      }
      &:hover {
        text-decoration: none;
      }
      &.selected {
        color: var(--action-color);
      }
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.fio {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      text-align: left;
      button:first-child {
        text-align: left;
      }
      &:hover {
        cursor: pointer;
        color: var(--action-color);
      }
    }
    &.success,
    &.fail,
    &.none {
      display: flex;
      align-items: center;
    }
    &.success:before,
    &.fail:before,
    &.none:before {
      content: '';
      height: 20px;
      margin-right: 10px;
      width: 20px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    &.success {
      background: #E4FFEC !important;
      &:before {
        background-image: url("@/assets/img/checked/all-checked-green.svg");
      }
    }
    &.fail {
      background: #FFECEC;
      &:before {
        background-image: url("@/assets/img/exit-red.svg");
      }
    }
    &.none:before {
      height: 6px;
      width: 6px;
      background: #ABB1A3;
      border-radius: 50%;
      margin: 0 10px 0 6px;
    }
  }
  &__cell.cda-completeness {
    font-size: 0px;
    &::after {
      font-size: 1rem;
    }
    &.empty::after {
      content: '-';
    }
    &.full::after {
      content: '+';
    }
    &.unknown::after {
      content: '?';
    }
  }
  &__message {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
  }
  &__icon {
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
    &-download {
      display: block;
      background-image: url("@/assets/img/download-file.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 20px;
      height: 20px;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
    &-copy {
      display: block;
      background-image: url("@/assets/img/copy-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      min-width: 14px;
      height: 14px;
      min-height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/copy-blue.svg");
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .product-unit-table {
    &__head,
    &__row {
      grid-template-columns: 60px repeat(2, 1fr) repeat(2, 43px);
      font-size: 12px;
      line-height: 17px;
    }
  }
}
@media screen and (max-width: 1100px) {
  .product-unit-table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      margin: 0 0 20px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 0;
      &.fio {
        text-align: right;
      }
    }
    &__cell::before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 480px) {
  .product-unit-table__body {
    display: none;
    &-mobile {
      display: flex;
    }
  }
}
</style>
